const $doc = $(document);
const chooseFile = '.browseFile';
const formDetailsContent = '.form-details-content';
const uploadedFile = '#uploadedFile';
const fileTypeNumber = '.fileTypeNumber';
const fileType = '.fileType';
const uploadDocumentForm = '.uploadDocumentForm';
const errorMsg = '.error-msg-text';
const documentsSelected = '.consentLink';
const browseButton = '.browse-button';

let fileTypeValue;
let fileExt;
const myDocuments = {
  uploadFile() {
    const acceptedFormats = ['jpg', 'jpeg', 'png', 'pdf'];
    const selectedElement = $(this)
      .parents(formDetailsContent)
      .find(chooseFile);

    const formContent = $(this).parents(uploadDocumentForm);
    const formId = formContent.attr('id');
    const fileextension = $(selectedElement)
      .val()
      .split('.')
      .pop()
      .toLowerCase();
    const file_data = $(selectedElement).prop('files')[0];
    const fileSize = file_data.size / 1024 / 1024;
    if (acceptedFormats.indexOf(fileextension) !== -1 && fileSize <= 10) {
      fileTypeValue = fileextension === 'pdf' ? '16' : '2';
      fileExt = fileextension;
      $(fileTypeNumber).val(fileTypeValue);
      $(fileType).val(fileExt);
      $(`#${formId}`).submit();
    } else {
      $(formContent)
        .find(errorMsg)
        .removeClass('hidden');
    }

    $(this)
      .parent(browseButton)
      .find('.choose-file')
      .focus();
  },

  init() {
    $doc.on('keypress', documentsSelected, function(e) {
      e.stopPropagation();
      if (e.keyCode === 13) {
        $(this)
          .find('a')
          .click(function() {
            this.click();
          })
          .click();
      }
    });
    $doc.on('keypress', browseButton, function(e) {
      const selectedFile = $(this).find(chooseFile);
      e.stopPropagation();
      if (e.keyCode === 13) {
        $(selectedFile).click();
      }
    });
    $doc.on('change', chooseFile, this.uploadFile);
  }
};
myDocuments.init();
export default myDocuments;
